import { render } from "./SetResultGame.vue?vue&type=template&id=347fcca0"
import script from "./SetResultGame.vue?vue&type=script&lang=js"
export * from "./SetResultGame.vue?vue&type=script&lang=js"

import "./SetResultGame.vue?vue&type=style&index=0&id=347fcca0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__